<div class="dialog">
  <div
    class="backdrop"
    role="button"
    tabindex="0"
    [attr.aria-label]="'CLOSE' | translate"
    (click)="close()"
    (keydown.enter)="close()"
    (keydown.space)="close()"
  ></div>

  <div class="content text-content">
    <div class="text-content__progress" [style.width.%]="progress()"></div>
    <div class="text-content__body">
      {{ currentText().start }}<span class="highlighted-chunk">{{ currentText().highlight }}</span
      >{{ currentText().end }}
    </div>
  </div>
  <div class="content controls-content">
    <div class="playback-buttons">
      <odl-button
        id="tts-prev-button"
        [description]="'TTS.PREVIOUS_SENTENCE' | translate"
        (click)="prev()"
      >
        <odl-icon name="skip_previous" slot="only-icon"></odl-icon>
      </odl-button>
      <odl-tooltip for="#tts-prev-button">{{ 'TTS.PREVIOUS_SENTENCE' | translate }}</odl-tooltip>

      <odl-button
        id="tts-play-button"
        class="play-button"
        [description]="(isPlaying() ? 'TTS.PAUSE' : 'TTS.PLAY') | translate"
        (click)="togglePlayback()"
      >
        <odl-icon [name]="isPlaying() ? 'pause' : 'play'" slot="only-icon"></odl-icon>
      </odl-button>
      <odl-tooltip for="#tts-play-button">
        {{ (isPlaying() ? 'TTS.PAUSE' : 'TTS.PLAY') | translate }}
      </odl-tooltip>

      <odl-button
        id="tts-next-button"
        [description]="'TTS.NEXT_SENTENCE' | translate"
        (click)="next()"
      >
        <odl-icon name="skip_next" slot="only-icon"></odl-icon>
      </odl-button>
      <odl-tooltip for="#tts-next-button">{{ 'TTS.NEXT_SENTENCE' | translate }}</odl-tooltip>
    </div>

    <div class="more-actions-buttons">
      @if (showRateButton()) {
        <odl-button
          id="rate-button"
          class="selector-button"
          variant="text"
          [class.selector-button--open]="isRateMenuOpen()"
          [description]="'TTS.PLAYBACK_SPEED' | translate"
        >
          {{ selectedRate() | number: '1.1-2' }}x
        </odl-button>
        <odl-tooltip for="#rate-button">{{ 'TTS.PLAYBACK_SPEED' | translate }}</odl-tooltip>
        <odl-menu
          for="#rate-button"
          (odl-before-open)="isRateMenuOpen.set(true)"
          (odl-open)="moveToSelected($event)"
          (odl-before-close)="isRateMenuOpen.set(false)"
        >
          <odl-menu-title>{{ 'TTS.PLAYBACK_SPEED' | translate }}</odl-menu-title>

          @for (rate of rates(); track rate) {
            <odl-menu-item
              type="checkbox"
              [checked]="this.selectedRate() === rate"
              (odl-select)="selectRate(rate)"
            >
              {{ rate | number: '1.1-2' }}x

              @if (rate === 1.0) {
                ({{ 'TTS.RATE_DEFAULT_LABEL' | translate }})
              }
            </odl-menu-item>
          }
        </odl-menu>
      }

      @if (showVoiceButton()) {
        <odl-button
          id="voice-button"
          class="selector-button"
          variant="text"
          [class.selector-button--open]="isVoiceMenuOpen()"
          [description]="'TTS.VOICE' | translate"
        >
          {{ selectedVoice()?.lang }}
        </odl-button>
        <odl-tooltip for="#voice-button">{{ 'TTS.VOICE' | translate }}</odl-tooltip>
        <odl-menu
          for="#voice-button"
          (odl-before-open)="isVoiceMenuOpen.set(true)"
          (odl-open)="moveToSelected($event)"
          (odl-before-close)="isVoiceMenuOpen.set(false)"
        >
          <odl-menu-title>{{ 'TTS.VOICE' | translate }}</odl-menu-title>

          @for (voice of sortedVoices(); track voice.voiceURI) {
            <odl-menu-item
              type="checkbox"
              [checked]="this.selectedVoice()?.voiceURI === voice.voiceURI"
              (odl-select)="selectVoice(voice)"
            >
              {{ voice.name }}
            </odl-menu-item>
          }
        </odl-menu>
      }

      @if (showMobileActions()) {
        <nr-mobile-more-actions>
          <ng-container slot="rate-submenu">
            @for (rate of rates(); track rate) {
              <odl-menu-item
                slot="submenu"
                type="checkbox"
                [checked]="this.selectedRate() === rate"
                (odl-select)="selectRate(rate)"
              >
                {{ rate | number: '1.1-2' }}x

                @if (rate === 1.0) {
                  ({{ 'TTS.RATE_DEFAULT_LABEL' | translate }})
                }
              </odl-menu-item>
            }
          </ng-container>

          <ng-container slot="voice-submenu">
            @for (voice of sortedVoices(); track voice.voiceURI) {
              <odl-menu-item
                slot="submenu"
                type="checkbox"
                [checked]="this.selectedVoice()?.voiceURI === voice.voiceURI"
                (odl-select)="selectVoice(voice)"
              >
                {{ voice.name }}
              </odl-menu-item>
            }
          </ng-container>
        </nr-mobile-more-actions>
      }
    </div>
  </div>
</div>
